<template>
  <div>
    <v-dialog v-model="dialog" max-width="400px" persistent>
      <v-card >
        <v-card-title >
          <span class="font-weight-bold">구역정보 선택</span>
        </v-card-title>
        <v-divider></v-divider>
          <div style="overflow-x: auto; overflow-y: auto; width:100%; height:calc(100vh - 500px); padding:10px; background-color:#ffffff">
            
            <v-treeview
              v-model="selection"
              selection-type="leaf"
              :items="items"
              selectable
              :activatable="true" 
              hoverable
              open-on-click
              dense
              :open.sync="open">
            </v-treeview>
          </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false;" text class="mr-2"><v-icon class="mr-2">mdi-close</v-icon>취소</v-btn>
          <v-btn @click="CloseDialog()" dark class="ml-2"><v-icon class="mr-2">save</v-icon>확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";

import { mapState } from "vuex";

export default {
  components: {
  },
  data: () => ({
    dialog : false,
    cFistZoneNm : "",
    cSecondZoneNm : "",
    zVisitPlace : [],
    items : [],
    selection : [],
    open : [],
    zAllData : [],
    zResult : [],
    zLevNm1 : [],
    zLevNm2 : [],
    zLevNm3 : [],
  }),
  computed: {
    ...mapState(["CustomInfo"]),
  },

  created() {
  },

  mounted() {
  },

  methods : {
    ShowDialog(selected){
      this.dialog = true;
      this.zVisitPlace = selected;
      this.GetMapTreeInfo();
    },

    //지도 정보 가져오기
    GetMapTreeInfo() {
      this.open = [];
      this.items = [];

      var posData = {
        SiteId : this.CustomInfo.SiteId,
        cCustomId : this.CustomInfo.CustomId,
      };
      axios
        .post(process.env.VUE_APP_UIL_API + "GetMapTreeInfo", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            this.zResult = res.data.Result;

            for (let i = 0; i < res.data.Result.length; i++) {
              if (res.data.Result[i].iLev == 0) {
                let item = {
                  id: res.data.Result[i].cId,
                  cMapGroupId: res.data.Result[i].cMapGroupId,
                  cBuildingId: res.data.Result[i].cBuildingId,
                  cGroupId: res.data.Result[i].cGroupId,
                  name: res.data.Result[i].cMapNm,
                  file: res.data.Result[i].cFileId,
                  iLev: res.data.Result[i].iLev,
                  Path: process.env.VUE_APP_FILE_API + res.data.Result[i].cPath,
                  Order: res.data.Result[i].cOrder,
                  cType : res.data.Result[i].cType,                
                  cParentNm : "",
                  children: [],
                }
                this.items.push(item);           
                
                this.open.push(item.id);
              }              
            }

            for (let i = 0; i < res.data.Result.length; i++) {
              if (res.data.Result[i].iLev == 1) {                
                let item = {
                  id: res.data.Result[i].cId,
                  cMapGroupId: res.data.Result[i].cMapGroupId,
                  cBuildingId: res.data.Result[i].cBuildingId,
                  cGroupId: res.data.Result[i].cGroupId,
                  name: res.data.Result[i].cMapNm,
                  file: res.data.Result[i].cFileId,
                  iLev: res.data.Result[i].iLev,
                  Path: process.env.VUE_APP_FILE_API + res.data.Result[i].cPath,
                  Order: res.data.Result[i].cOrder,                
                  cType : res.data.Result[i].cType,                
                  cParentNm : this.items[0].name,
                  children: [],
                }
                this.items[0].children.push(item);            
              }              
            }

            for (let i = 0; i < res.data.Result.length; i++) {
              if (res.data.Result[i].iLev == 2) {
                for (let j = 0; j < this.items[0].children.length; j++) {
                  if (this.items[0].children[j].cMapGroupId == res.data.Result[i].cMapGroupId) {     
                    let item = {
                      id: res.data.Result[i].cId,
                      cMapGroupId: res.data.Result[i].cMapGroupId,
                      cBuildingId: res.data.Result[i].cBuildingId,
                      cGroupId: res.data.Result[i].cGroupId,
                      name: res.data.Result[i].cMapNm,
                      file: res.data.Result[i].cFileId,
                      iLev: res.data.Result[i].iLev,
                      Path: process.env.VUE_APP_FILE_API + res.data.Result[i].cPath,
                      Order: res.data.Result[i].cOrder,
                      cType : res.data.Result[i].cType,                
                      cParentNm : this.items[0].children[j].name,
                      children: [],
                    }

                    this.items[0].children[j].children.push(item);
                    break;
                  }
                }
              }              
            }

            for (let i = 0; i < res.data.Result.length; i++) {
              if (res.data.Result[i].iLev == 3) {
                for (let j = 0; j < this.items[0].children.length; j++) {
                  for (let k = 0; k < this.items[0].children[j].children.length; k++) {
                    if (this.items[0].children[j].children[k].cMapGroupId == res.data.Result[i].cMapGroupId && this.items[0].children[j].children[k].cBuildingId == res.data.Result[i].cBuildingId) {
                      let item = {
                        id: res.data.Result[i].cId,
                        cMapGroupId: res.data.Result[i].cMapGroupId,
                        cBuildingId: res.data.Result[i].cBuildingId,
                        cGroupId: res.data.Result[i].cGroupId,
                        name: res.data.Result[i].cMapNm,
                        file: res.data.Result[i].cFileId,
                        iLev: res.data.Result[i].iLev,
                        Path: process.env.VUE_APP_FILE_API + res.data.Result[i].cPath,
                        Order: res.data.Result[i].cOrder,
                        cType : res.data.Result[i].cType,                
                        cParentNm : this.items[0].children[j].children[k].name,
                        children: [],
                      }

                      this.items[0].children[j].children[k].children.push(item);
                      break;
                    }
                  }
                }
              }
            }

            this.SetLevAllNm();
            this.SetAll();
            this.SetIni();
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    SetLevAllNm(){
      this.zLevNm1 = [];
      this.zLevNm2 = [];
      this.zLevNm3 = [];

      let cLevel1Nm = ""
      let cLevel2Nm = ""
      let cLevel3Nm = ""

      for (let j = 0; j < this.items[0].children.length; j ++) {
        cLevel1Nm = cLevel1Nm + this.items[0].children[j].name + ", "

        if (j == this.items[0].children.length-1) {
          let item = {
            cName : cLevel1Nm.slice(0,-2),
            cParentNm : this.items[0].children[j].cParentNm,
          }

          this.zLevNm1.push(item)
          cLevel1Nm = ""
        }

        for (let k = 0; k < this.items[0].children[j].children.length; k++) {
          cLevel2Nm = cLevel2Nm + this.items[0].children[j].children[k].name + ", "

          if (k == this.items[0].children[j].children.length-1) {
            let item = {
              cName : cLevel2Nm.slice(0,-2),
              cParentNm : this.items[0].children[j].children[k].cParentNm,
            }
            
            this.zLevNm2.push(item)
            cLevel2Nm = ""
          }

          for (let m = 0; m < this.items[0].children[j].children[k].children.length; m++) {
            cLevel3Nm = cLevel3Nm + this.items[0].children[j].children[k].children[m].name + ", "

            if (m == this.items[0].children[j].children[k].children.length-1) {
              let item = {
                cName : cLevel3Nm.slice(0,-2),
                cParentNm : this.items[0].children[j].children[k].children[m].cParentNm,
              }
              
              this.zLevNm3.push(item)
              cLevel3Nm = ""
            }
          }
        }
      }
    },
    
    SetAll(){
      this.zAllData = [];

      for (let i in this.items) {
        if (this.items[i].children.length == 0) {
          this.zAllData.push(this.items[i].id);
        } else {
          for (let j in this.items[i].children) {
            if (this.items[i].children[j].children.length == 0) {
              this.zAllData.push(this.items[i].children[j].id);
            } else {              
              for (let k in this.items[i].children[j].children) {
                if (this.items[i].children[j].children[k].children.length == 0) {
                  this.zAllData.push(this.items[i].children[j].children[k].id);
                }  else {
                  for (let l in this.items[i].children[j].children[k].children) {
                    this.zAllData.push(this.items[i].children[j].children[k].children[l].id);
                  }
                }
              }
            }
          }
        }
      }
    },

    // selection 안에 zVisitPlace 데이터 반영 하기
    SetIni(){
      this.selection = [];

      for (let i in this.zVisitPlace){
        this.selection.push(this.zVisitPlace[i]);
      }
      // for (let i in this.zVisitPlace){
      //   for (let j in this.zAllData){
      //     if (this.isAddCheck(this.zVisitPlace[i], this.zAllData[j])){
      //       this.selection.push(this.zAllData[j]);
      //     }
      //   }
      // }
    },

    // // zVisitPlace 안에있는 데이터를 확인 후 selection안에 넣을지 말지 선택 
    // isAddCheck(org, data){
    //   if (org.substring(0,2) == "00") {
    //     return true;
    //   } else if (org.substring(2,4) == "00") {
    //     if (org.substring(0,2) == data.substring(0,2)) {
    //       return true;
    //     }        
    //   } else {
    //     if (org == data) {
    //       return true;
    //     }        
    //   }
    //   return false;
    // },

    // 선택 시 가장하위의 단위들은 없어서 반복문을 돌려 찾아서 넣어줌
    getData() {
      var zRealData = [];

      if (this.selection.length == this.zAllData.length) {
        zRealData.push("000000");        
        return zRealData;
      } 

      for (let i in this.items) {
        // this.items[i].children >> 1단지,2단지,본관
        if (this.items[i].children.length != 0) {
          for (let j in this.items[i].children) {
            if (this.items[i].children[j].children.length == 0 && this.items[i].children[j].cGroupId == "00") {
              if (this.selection.includes(this.items[i].children[j].id)) {
                zRealData.push(this.items[i].children[j].id);
              }
            }

            if (this.items[i].children[j].children.length != 0) {
              for (let k in this.items[i].children[j].children) {
                if (this.items[i].children[j].children[k].children.length == 0 && this.items[i].children[j].children[k].cGroupId == "00") {
                  if (this.selection.includes(this.items[i].children[j].children[k].id)) {
                    zRealData.push(this.items[i].children[j].children[k].id);
                  }
                }

                if (this.items[i].children[j].children[k].children.length != 0) {
                  let iFindCount = 0;
                  let zTemp = [];

                  for (let l in this.items[i].children[j].children[k].children) {
                    if (this.selection.includes(this.items[i].children[j].children[k].children[l].id)) {
                      iFindCount = iFindCount+1;                    
                      zTemp.push(this.items[i].children[j].children[k].children[l].id);
                    }
                  }

                  if (iFindCount > 0) {
                    if (iFindCount == this.items[i].children[j].children[k].children.length){
                      zRealData.push(this.items[i].children[j].children[k].id);
                    } else {
                      for (let z in zTemp) {
                        zRealData.push(zTemp[z]);
                      }
                    }
                  }
                }
              }
            }   
          }
        }
      }     

      return zRealData;
    },

    // 다이올로그 창 닫기
    CloseDialog(){
      // 260320 skst뿐만 아니라 skma도 tree구조 반영해야함
      if (this.$store.state.CustomInfo.SiteId != "SKST" && this.$store.state.CustomInfo.SiteId != "SKMA") {
        let cMapTreeNm = "";
        for (let i = 0; i < this.selection.length; i++) {
          for (let j = 0; j < this.items.length; j++) {
            if (this.selection[i] == this.items[j].id) {
              if (cMapTreeNm != "" ) {
                cMapTreeNm = cMapTreeNm + ", ";
              }  
              cMapTreeNm = cMapTreeNm + this.items[j].name;              
              break;
            }
          }
        }
        this.dialog = false;
        this.$emit("SetMap",this.selection,cMapTreeNm)
      } else {
        var cMapTreeNm = "";
  
        let zResultData = this.getData();      
  
        for (let i = 0; i < zResultData.length; i++) {
          if (zResultData[i] == "000000") {
            cMapTreeNm = "사업장전체";
            break;
          }
  
          for (let j = 0; j < this.zResult.length;j++) {          
            if (this.zResult[j].cId == zResultData[i]) {
              if (cMapTreeNm != "" ) {
                cMapTreeNm = cMapTreeNm + ", ";
              }
  
              cMapTreeNm = cMapTreeNm + this.zResult[j].cMapNm;
              break;
            }          
          }
        }
  
        for (let i = 0; i < this.zLevNm3.length;i ++) {
          cMapTreeNm = cMapTreeNm.replace(this.zLevNm3[i].cName,this.zLevNm3[i].cParentNm)
        }
  
        for (let j = 0; j < this.zLevNm2.length;j ++) {
          cMapTreeNm = cMapTreeNm.replace(this.zLevNm2[j].cName,this.zLevNm2[j].cParentNm)
        }
  
        for (let k = 0; k < this.zLevNm1.length;k ++) {
          cMapTreeNm = cMapTreeNm.replace(this.zLevNm1[k].cName,this.zLevNm1[k].cParentNm)
        }
        
        
        // this.$emit("SetMap",this.zRealData,cMapTreeNm)
  
        this.dialog = false;
        this.$emit("SetMap",zResultData,cMapTreeNm)
      }
    },
  }
}
</script>